<template>
  <div>
    <template v-if="isImporter">
      <h2>{{ i18n.t('/PurchaseOrder/OpmerkingDispo') }}</h2>
      <input
        id="dispo-note"
        v-model="dispoValue"
        class="dispo-note-input-element"
        type="text"
        :class="{ 'gray-text': isTextGray }"
        maxlength="30"
        @blur="updateOrderReference"
      />
      <div v-if="canShowCharacters" class="dispo-note-message">
        <label v-if="remainingCharacters > 0"> U kan nog {{ remainingCharacters }} invoeren </label>
        <label v-if="remainingCharacters === 0">
          Maximum bereikt. U kunt geen karakters meer toevoegen
        </label>
      </div>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: {
    purchaseOrderId: {
      type: String,
      default: '',
    },
    purchaseOrderReference: {
      type: String,
      default: '',
    },
  },
  emits: ['change-dispo-note'],
  data() {
    return {
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
      dispoValue: initDispoValue.call(this),
    }
    function initDispoValue() {
      return this.purchaseOrderReference || this.purchaseOrderId || ''
    }
  },
  computed: {
    ...mapState('user', ['dealerSettings']),
    isTextGray() {
      return !this.purchaseOrderReference && this.purchaseOrderId
    },
    canShowCharacters() {
      return 30 - this.dispoValue.length < 10
    },
    remainingCharacters() {
      return 30 - this.dispoValue.length
    },
    isImporter() {
      return this.dealerSettings.isImporter
    },
  },
  methods: {
    updateOrderReference() {
      this.$emit('change-dispo-note', this.dispoValue)
    },
  },
}
</script>

<style lang="scss" scoped>
input[type='text'] {
  width: 100%;
}
h2 {
  font-size: 1.46191rem;
  margin-bottom: var(--space-xxs);
}

.gray-text {
  color: #d3d3d3;
}

.dispo-note-input-element {
  width: 350px !important;
}

.dispo-note-message {
  label {
    font-size: 18px;
    color: #d3d3d3;
  }
}
</style>
